import React, { useEffect, useState } from 'react';
import notificationIcon from "../../assets/Icons/notification_without_dot_icon.svg";
import filtersIcon from "../../assets/Icons/filters_icon.svg";
import arrow_down_icon from "../../assets/Icons/arrow_down_icon.svg";
import searchIcon from "../../assets/Icons/search_icon.svg"
import "./notifications.scss";


export const Notifications = ({ viewNotificatons }) => {

    const notifications = [
        {
            username: "Eric Haag",
            content: "commented on the incident (TEST - Report a system problem)",
            time: "Approximately one hour ago"
        },
        {
            username: "Eric Haag",
            content: "has created a new incident (Incident Sep / 2020)",
            time: "Approximately one hour ago"
        },
        {
            username: "Eric Haag",
            content: "commented on the incident (TEST - Report a system problem)",
            time: "Approximately one hour ago"
        },
        {
            username: "Eric Haag",
            content: "has shared a new dashboard (aircraft) with you.",
            time: "Approximately one hour ago"
        },
        {
            username: "Eric Haag",
            content: "has shared a new dashboard (Lorem ipsum dolor sit amet) with you.",
            time: "Approximately one hour ago"
        },
        {
            username: "Eric Haag",
            content: "has shared a new dashboard (Age of Parts in Months) with you.",
            time: "Approximately one hour ago"
        },
        {
            username: "Eric Haag",
            content: "commented on the incident (TEST - Report a system problem)",
            time: "Approximately one hour ago"
        },
        {
            username: "Eric Haag",
            content: "has shared a new dashboard (aircraft) with you.",
            time: "Approximately one hour ago"
        },
        {
            username: "Eric Haag",
            content: "has shared a new dashboard (Lorem ipsum dolor sit amet) with you.",
            time: "Approximately one hour ago"
        },
        {
            username: "Eric Haag",
            content: "has shared a new dashboard (Age of Parts in Months) with you.",
            time: "Approximately one hour ago"
        },
    ]

    const [visualizeNotifications, setVisualizeNotifications] = useState(viewNotificatons);

    const showMenuNotifications = () => {
        setVisualizeNotifications(true)
    }
    
    const hiddeNotifications = ()=>{
        setVisualizeNotifications(false)
    }


    useEffect(() => {
        setVisualizeNotifications(viewNotificatons)
    }, [viewNotificatons])


    return (
        <menu className={`notifications-menu bg-white ${visualizeNotifications ? "viewMenuNotifications" : ""}`}
            onClick={()=>setVisualizeNotifications(prev => !prev)}
        >

            <section className="filters-section">
                <span>
                    <img src={notificationIcon} alt="" />
                    <h4 className='txt-black'>Notifications</h4>
                </span>
                <div className='filters-cont'>
                    <img src={filtersIcon} alt="" />
                    <p className='txt-black'>Filters</p>
                    <img src={arrow_down_icon} alt="" className='view-filters-icon' />
                </div>
            </section>

            <section className="search-notifications-section" >
                <div className="search-cont">
                    <input type="text" placeholder='Search' />
                    <img src={searchIcon} alt="" />
                </div>
            </section>
            <section className="notifications-section" >
                {
                    notifications.map((notification , index) => {
                        return <span className='notification bg-white-100' key={index}>
                            <span className="user-icon-notification">
                                <div className='txt-white'>
                                    A
                                </div>
                            </span>
                            <section className="notification-content">
                                <p className='txt-black-mid'> <span>{notification.username}</span> {notification.content}</p>
                                <span>{notification.time}</span>
                            </section>
                        </span>
                    })
                }
            </section>
        </menu>
    )
}
